enum MapQueryParams {
  MappingType = "mt",
  PrimaryStation = "ps",
}

export enum MapTypeParam {
  NewMapping = "nm",
  ContinueMapping = "cm",
  RedoMapping = "rm",
  TransitionMapping = "tm"
}

export default MapQueryParams
